/**
 * The one rule for colouring a financial value by its sign.
 *
 * Profit is green, loss is red, and unmoved is neither. Zero matters: a
 * position that has not moved is not a small win, and a dashboard that paints
 * it green has said something untrue about it.
 *
 * This lives on its own because the dashboard shows the same idea in three
 * places — a live position's profit, the account's floating P/L, and the
 * realised figures on the performance page — and they were drifting. The
 * positions table left a loss in the default text colour, so the number a
 * trader most needs to read at a glance was the only one that never turned
 * red.
 *
 * It applies **only** where a value is directionally financial. An account
 * balance, an equity level and a margin percentage are states, not results:
 * they have no positive or negative meaning to colour, and they are left
 * alone deliberately.
 */

export function financialTone(value) {
  const amount = Number(value);
  if (value === null || value === undefined || value === "") return "";
  if (!Number.isFinite(amount) || amount === 0) return "";
  return amount > 0 ? "positive" : "negative";
}

/** The same rule as a ready-made class name, for markup that takes one. */
export function financialToneClass(value) {
  const tone = financialTone(value);
  return tone ? `is-${tone}` : "";
}
